import { IBankStrategy, IBankItem } from '@/api/signup/interface';
import { logger } from './logger';
import { Store } from 'vuex';
import { audit } from './audit';

interface IPersistedStore {
  token: string;
  strategy: IBankStrategy;
  bank?: IBankItem;
  bankSearch?: string;
}

export const persistStore = (key: string, store: any) => {
  if (
    !store.signup ||
    !store.signup.strategy ||
    !store.signup.strategy.data ||
    !store.signup.strategy.data.requestId
  ) {
    logger.critical('trying to persist invalid store!');
    return;
  }
  const p: IPersistedStore = {
    token: store.token,
    bank: store.signup.bank,
    strategy: store.signup.strategy,
    // bank: (store.user && store.user.bank) || undefined,
    // bankSearch: (store.user && store.user.bankSearch) || undefined
  };
    if ( window == window.parent ) 
  {
    localStorage.setItem(key, JSON.stringify(p));
  } 
};

export const rehydrateStore = (key: string, store: Store<any>) => {
  audit({
    action: 'starting-rehydrate-store',
    info: {
      state: key,
    },
  });
  const i = localStorage.getItem(key);
  audit({
    action: 'rehydrate-store',
    info: {
      state: key,
      item: i,
    },
  });
  if (!i) {
    logger.critical("couldn't retrive persisted using", key);
    return;
  }
  const v: IPersistedStore = JSON.parse(i);
  if (!v.token) {
    logger.critical('token not found on the persisted', i);
    return;
  }
  if (!v.strategy) {
    logger.critical('strategy not found on the persisted', i);
    return;
  }
  if (!v.strategy.data.requestId) {
    logger.critical('requestId not found on the persisted', i);
    return;
  }

  const s = {
    ...store.state,
    token: v.token,
    signup: {
      ...store.state.signup,
      strategy: v.strategy,
      bank: v.bank,
    },
  };
  store.replaceState(s);
};
